/* tslint:disable */
/* eslint-disable */
import { DocumenttypeDisplayModel as AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/documenttype-display-model';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { DocumenttypeDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModelFormGroup } from '@/api/model-index';

export interface IDocumentDisplayModel {
  content?: null | string;
  contentMimeType?: null | string;
  documentId?: null | string;
  documententyp?: AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModel;
  fileSize?: number;
  herkunftsnachweis?: null | string;
  name?: null | string;
  paymentId?: null | string;
}
export class DocumentDisplayModel extends BaseModel implements IDocumentDisplayModel {
  content?: null | string;
  contentMimeType?: null | string;
  documentId?: null | string;
  documententyp?: AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModel;
  fileSize?: number;
  herkunftsnachweis?: null | string;
  name?: null | string;
  paymentId?: null | string;
}
class BaseDocumentDisplayModelFormGroup extends FormGroup {
  private static _instance: DocumentDisplayModelFormGroup;
  
  public static get Instance(): DocumentDisplayModelFormGroup {
    this._instance = new DocumentDisplayModelFormGroup({
      content: new FormControl(null),
      contentMimeType: new FormControl(null),
      documentId: new FormControl(null),
      documententyp: AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModelFormGroup.Instance,
      fileSize: new FormControl(null),
      herkunftsnachweis: new FormControl(null),
      name: new FormControl(null),
      paymentId: new FormControl(null),
    });

    return this._instance;
  }
}


export class DocumentDisplayModelFormGroup extends BaseDocumentDisplayModelFormGroup {
  public get Content(): FormControl {
    return this.controls["content"] as FormControl;
  }
  public get ContentMimeType(): FormControl {
    return this.controls["contentMimeType"] as FormControl;
  }
  public get DocumentId(): FormControl {
    return this.controls["documentId"] as FormControl;
  }
  public get Documententyp(): AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModelFormGroup {
    return this.controls["documententyp"] as AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModelFormGroup;
  }
  public get FileSize(): FormControl {
    return this.controls["fileSize"] as FormControl;
  }
  public get Herkunftsnachweis(): FormControl {
    return this.controls["herkunftsnachweis"] as FormControl;
  }
  public get Name(): FormControl {
    return this.controls["name"] as FormControl;
  }
  public get PaymentId(): FormControl {
    return this.controls["paymentId"] as FormControl;
  }
  

}

export module DocumentDisplayModelForm
  {
    export class FormFields
    {
      static _content: string = "content";
      static _contentMimeType: string = "contentMimeType";
      static _documentId: string = "documentId";
      static _documententyp: string = "documententyp";
      static _fileSize: string = "fileSize";
      static _herkunftsnachweis: string = "herkunftsnachweis";
      static _name: string = "name";
      static _paymentId: string = "paymentId";
    }
  }

